"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/****
 * 前端部分页面投票行情行
 *
 *  */
var utils_1 = __importDefault(require("../commonutil/utils"));
var webconfig = require('../../../config/web.js');
var web_1 = __importDefault(require("../myfavor/web"));
/**
 * 头部公用行情模块
 * @param hqcode 行情股票代码
 * @param $dom 对应的DOM
 * @param type 1：不带链接，有昨收今开最高最低；2：带链接，无昨收今开最高最低;默认是1
 * @param hrefhtml type为2的情况下，传过来的链接地址的html代码；参照：股东户数（gdhs）
 */
function default_1(hqcode, $dom, type, hrefhtml) {
    if (type === void 0) { type = 1; }
    if (hrefhtml === void 0) { hrefhtml = ''; }
    return __awaiter(this, void 0, void 0, function () {
        var tableCache, reqdata, arr, k, urlzs, back, data, html;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    tableCache = '';
                    if (type == 1) {
                        tableCache = "<table cellpadding=\"0\" cellspacing=\"0\" class=\"tophqtable\"><thead><tr><th>\u4EE3\u7801</th><th>\u540D\u79F0</th><th>\u6700\u65B0\u4EF7</th><th>\u6DA8\u8DCC\u989D</th><th>\u6DA8\u8DCC\u5E45(%)</th><th>\u632F\u5E45(%)</th><th>\u6210\u4EA4\u91CF(\u624B)</th><th>\u6210\u4EA4\u989D(\u4E07)</th><th>\u6628\u6536</th><th>\u4ECA\u5F00</th><th>\u6700\u9AD8</th><th>\u6700\u4F4E</th><th>\u6362\u624B\u7387(%)</th><th>\u91CF\u6BD4</th><th>\u5E02\u76C8\u7387</th>\n        <th>\u52A0\u81EA\u9009</th></tr></thead><tbody><tr><td><a href=\"//quote.eastmoney.com/unify/r/" + hqcode + "\" target=\"_blank\">{code}</a></td><td><a href=\"/stockdata/{code}.html\" target=\"_blank\">{name}</a></td><td>{price}</td><td>{change}</td><td>{percent}</td><td><span>{zf}</span></td>\n        <td><span>{volume}</span></td><td><span>{amount}</span></td><td>{last}</td><td>{open}</td><td>{height}</td><td>{low}</td><td><span>{hsl}</span></td><td><span>{lb}</span></td><td><span>{syl}</span></td><td><img src=\"/newstatic/images/add.gif\" class=\"addFav\" data='" + hqcode + "' style=\"cursor:pointer\"></td></tr></tbody></table>";
                    }
                    else if (type == 2) {
                        tableCache = "<table cellpadding=\"0\" cellspacing=\"0\" class=\"tophqtable\"><thead><tr><th>\u4EE3\u7801</th><th>\u540D\u79F0</th><th>\u76F8\u5173\u94FE\u63A5</th><th>\u6700\u65B0\u4EF7</th><th>\u6DA8\u8DCC\u989D</th><th>\u6DA8\u8DCC\u5E45(%)</th><th>\u632F\u5E45(%)</th><th>\u6210\u4EA4\u91CF(\u624B)</th><th>\u6210\u4EA4\u989D(\u4E07)</th><th>\u6362\u624B\u7387(%)</th><th>\u91CF\u6BD4</th><th>\u5E02\u76C8\u7387</th>\n        <th>\u52A0\u81EA\u9009</th></tr></thead><tbody><tr><td><a href=\"//quote.eastmoney.com/unify/r/" + hqcode + "\" target=\"_blank\">{code}</a></td><td><a href=\"/stockdata/{code}.html\" target=\"_blank\">{name}</a></td><td>{hrefhtml}</td><td>{price}</td><td>{change}</td><td>{percent}</td><td><span>{zf}</span></td>\n        <td><span>{volume}</span></td><td><span>{amount}</span></td><td><span>{hsl}</span></td><td><span>{lb}</span></td><td><span>{syl}</span></td><td><img src=\"/newstatic/images/add.gif\" class=\"addFav\" data='" + hqcode + "' style=\"cursor:pointer\"></td></tr></tbody></table>";
                    }
                    reqdata = {
                        fltt: "2",
                        invt: "2",
                        secid: hqcode,
                        fields: "f57,f58,f107,f43,f169,f170,f171,f47,f48,f60,f46,f44,f45,f168,f50,f162,f292,f59,f152",
                        ut: "b2884a393a59ad64002292a3e90d46a5"
                    };
                    arr = [];
                    for (k in data) {
                        arr.push(k + "=" + data[k]);
                    }
                    urlzs = webconfig.getWebPath('quoteurl') + 'api/qt/stock/get';
                    return [4 /*yield*/, $.ajax({
                            url: urlzs,
                            type: 'GET',
                            dataType: 'jsonp',
                            jsonp: 'cb',
                            scriptCharset: "utf-8",
                            data: reqdata
                        })];
                case 1:
                    back = _a.sent();
                    data = back && back.data;
                    if (data) {
                        if (data.f292 == 7 || data.f292 == 8) {
                            return [2 /*return*/];
                        }
                        html = tableCache.replace(/{code}/ig, data["f57"])
                            .replace(/{name}/ig, data["f58"])
                            .replace(/{hrefhtml}/ig, hrefhtml)
                            .replace(/{price}/ig, '<span class="' + utils_1["default"].getColor(data["f170"]) + '">' + utils_1["default"].toFixed2(data["f43"], data.f59) + '</span>')
                            .replace(/{change}/ig, '<span class="' + utils_1["default"].getColor(data["f170"]) + '">' + utils_1["default"].toFixed2(data["f169"], data.f59) + '</span>')
                            .replace(/{percent}/ig, utils_1["default"].getColorByData(data["f170"], data.f152))
                            .replace(/{zf}/ig, utils_1["default"].toFixed2(data["f171"], data.f152))
                            .replace(/{volume}/ig, utils_1["default"].getTextValOrEmpty(data["f47"]))
                            .replace(/{amount}/ig, utils_1["default"].toFixed2(data["f48"] / 10000))
                            .replace(/{last}/ig, utils_1["default"].toFixed2(data["f60"], data.f59))
                            .replace(/{open}/ig, '<span class="' + utils_1["default"].getColor(data["f46"] - data["f60"]) + '">' + utils_1["default"].toFixed2(data["f46"], data.f59) + '</span>')
                            .replace(/{height}/ig, '<span class="' + utils_1["default"].getColor(data["f44"] - data["f60"]) + '">' + utils_1["default"].toFixed2(data["f44"], data.f59) + '</span>')
                            .replace(/{low}/ig, '<span class="' + utils_1["default"].getColor(data["f45"] - data["f60"]) + '">' + utils_1["default"].toFixed2(data["f45"], data.f59) + '</span>')
                            .replace(/{hsl}/ig, utils_1["default"].toFixed2(data.f168, data.f152))
                            .replace(/{lb}/ig, utils_1["default"].toFixed2(data.f50, data.f152))
                            .replace(/{syl}/ig, utils_1["default"].toFixed2(data.f162, data.f152));
                        $dom.html(html).show();
                        $('.addFav').off('click').on('click', function () {
                            var hqcode = $(this).attr('data');
                            web_1["default"].addDefaultStock(hqcode).then(function () {
                                window.open('//quote.eastmoney.com/zixuan/?from=data');
                            })["catch"](function (err) {
                                window.open('//quote.eastmoney.com/zixuan/?from=data');
                            });
                        });
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports["default"] = default_1;
